import React from 'react';
import PropTypes from 'prop-types';
import { useUrlLocalizer } from 'tradera-lang/translate';
import styles from './hover-menu-item.module.scss';

const HoverMenuItem = ({
    icon,
    label,
    link,
    border,
    follow,
    onClick,
    gaAttributes
}) => {
    const { toLocalizedUrl } = useUrlLocalizer();
    return (
        <li className={styles.item}>
            <a
                className={`${styles.link} d-flex align-items-center ${
                    border ? 'border-bottom' : ''
                }`}
                href={toLocalizedUrl(link)}
                onClick={onClick}
                {...(!follow && { rel: 'nofollow' })}
                {...gaAttributes}>
                <span
                    className={`${styles.icon} d-flex justify-content-center align-items-center`}>
                    {icon}
                </span>
                <span>{label}</span>
            </a>
        </li>
    );
};

HoverMenuItem.propTypes = {
    icon: PropTypes.node,
    label: PropTypes.node,
    link: PropTypes.string,
    border: PropTypes.bool,
    follow: PropTypes.bool,
    onClick: PropTypes.func,
    gaAttributes: PropTypes.object
};

export default HoverMenuItem;
